// Provider do relógio dos contadores. Opcional: sem ele os contadores caem no
// `globalTicker`, que também é único. Serve para (a) mudar a cadência numa tela
// específica e (b) congelar o tempo em teste/Storybook.
import { createContext, useContext, useMemo, useSyncExternalStore, type ReactNode } from 'react';
import { createTicker, globalTicker, type Ticker } from './ticker';

const TickerContext = createContext<Ticker>(globalTicker);

export interface CountdownTickerProviderProps {
  children: ReactNode;
  /** Cadência do relógio em ms. Default 1000. Ignorado quando `ticker` é passado. */
  intervalMs?: number;
  /** Injeta um ticker pronto (ex.: `createFrozenTicker` nos testes). */
  ticker?: Ticker;
}

export function CountdownTickerProvider({
  children,
  intervalMs = 1000,
  ticker,
}: CountdownTickerProviderProps) {
  const value = useMemo(() => ticker ?? createTicker(intervalMs), [ticker, intervalMs]);
  return <TickerContext.Provider value={value}>{children}</TickerContext.Provider>;
}

/** Instante atual (ms epoch) do ticker em escopo. Re-renderiza a cada tique. */
export function useCountdownTick(): number {
  const ticker = useContext(TickerContext);
  return useSyncExternalStore(ticker.subscribe, ticker.getSnapshot, ticker.getSnapshot);
}
